import type { JSX } from "react";

import { Stack } from "@mantine/core";

import { ConversationalSummary } from "./ConversationalSummary";
import { hasStandardIVRInfo } from "./hasStandardIVRInfo";
import { Header } from "./Header";
import { IVRSummary } from "./IVRSummary";

interface CustomerHandoffProps {
    summary?: string;
    productLink?: string;
    productTitle?: string;

    conversationalSummary?: string;
    customerName?: string;
}

export function CustomerHandoff({
    summary,
    productLink,
    productTitle,
    conversationalSummary,
    customerName,
}: CustomerHandoffProps): JSX.Element | null {
    if (!conversationalSummary && !hasStandardIVRInfo({ summary, productLink, productTitle })) return null;

    return (
        <Stack gap={0}>
            <Stack align="center" pt="md">
                <Header text="What we know" />
            </Stack>
            {conversationalSummary ? (
                <ConversationalSummary conversationalSummary={conversationalSummary} customerName={customerName} />
            ) : (
                <IVRSummary summary={summary} productLink={productLink} productTitle={productTitle} />
            )}
        </Stack>
    );
}
